document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.bp-bestsellers').forEach((section) => {

    const slider = section.querySelector('.bp-bestsellers__slider');

    if (!slider) return;

    const prev = section.querySelector('.bp-prev');
    const next = section.querySelector('.bp-next');

    const scrollAmount = 320;

    if (next) {
      next.addEventListener('click', () => {
        slider.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        });
      });
    }

    if (prev) {
      prev.addEventListener('click', () => {
        slider.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth'
        });
      });
    }

  });

});